/* eslint-disable react-native/no-inline-styles */
import { Text } from '@Components/Common/Text';
import useCheckoutPresenter from '@Screens/Checkout/presenter';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';

import CollectPaymentAddress from '../SharedComponents/CollectPaymentAddress';

import { useCheckoutStore } from '~stores/checkout';

const Section = styled.View`
  display: flex;
  width: 100%;
  padding-top: 40px;
  margin-top: 30px;
  border-top-width: 2px;
  border-top-color: #dcdcdc;
`;

const StyledRow = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
`;

type IProps = {
  checkoutIsSubmitting: boolean;
};

const PaymentOptionsSection: React.FC<IProps> = ({ checkoutIsSubmitting }) => {
  const { addCardFormVisible, selectedCard } = useCheckoutStore();
  const { onChangePaymentPressed, paymentInputActionTitle } =
    useCheckoutPresenter();

  return (
    <Section>
      <StyledRow>
        <Text weight='bold' size='xs' color={OwnableTheme.colors.black}>
          Payment Options
        </Text>
        <Pressable onPress={onChangePaymentPressed}>
          <Text size='xs' color={OwnableTheme.colors.black}>
            {paymentInputActionTitle}
          </Text>
        </Pressable>
      </StyledRow>

      {addCardFormVisible && (
        <CollectPaymentAddress checkoutIsSubmitting={checkoutIsSubmitting} />
      )}
      {Boolean(selectedCard) && !addCardFormVisible && (
        <>
          <Text
            color='black'
            size='xs'
            fontStyleOverride={{
              fontFamily: OwnableTheme.fonts.gilroy.light,
              lineHeight: 19,
              fontWeight: '500',
            }}
          >
            {`xxxx xxxx xxxx ${selectedCard?.last4Digits}`}
          </Text>
        </>
      )}
    </Section>
  );
};

export default observer(PaymentOptionsSection);
